/** 运费账单核对-列表*/
export const TMS_SETTLE_SELECTLIST = {
  url: 'api/tms/adaptation/transport/settle/carrier/select/list',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/** 运费账单核对-总数*/
export const TMS_SETTLE_BATCH_ALLNUMBER = {
  url: 'api/tms/adaptation/transport/settle/carrier/select/tab/count',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/** 运费账单核对-批量确认*/
export const TMS_SETTLE_BATCH_CONFIRM = {
  url: 'api/tms/adaptation/transport/settle/carrier/batch/confirmation',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/** 运费账单核对-批量拒绝*/
export const TMS_SETTLE_BATCH_REFUSE = {
  url: 'api/tms/adaptation/transport/settle/carrier/batch/reject',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/** 运费账单核对-其他费用*/
export const TMS_SETTLE_BATCH_OTHER_FEE = {
  url: 'api/tms/adaptation/transport/settle/carrier/other/fee/Info',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/** 运费账单核对-费用归属*/
export const TMS_SETTLE_BATCH_OTHER_FEE_BELONG = {
  url: 'api/tms/adaptation/transport/settle/carrier/other/fee/belong',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

/** 运费账单核对-更新装车单其他费用提报发起申请*/
export const TMS_SETTLE_OTHER_FEE_UPDATE = {
  url: '/api/tms/transportSettle/tmsEntruckOrderOtherFeeUpdate',
  config: {
    method: 'POST',
    host: 'SUPPLIER',
    noWarn: true,
  },
};
/** 运费账单核对-所在仓库子客户模糊查询*/
export const TMS_SETTLE_OTHER_FEE_DC_LIST = {
  url: '/api/tms/customer/child/selectByOtherWareHouseCode',
  config: {
    method: 'POST',
    host: 'SUPPLIER',
  },
};
/** 运费账单核对-获取费用类型列表*/
export const TMS_SETTLE_OTHER_FEE_TYPE_LIST = {
  url: '/api/tms/feeconfig',
  config: {
    method: 'GET',
    host: 'SUPPLIER',
  },
};

/** 运费账单核对-折扣*/
export const TMS_SETTLE_BATCH_OTHER_DEDUCT_FEE_INFO = {
  url: 'api/tms/adaptation/transport/settle/carrier/deduct/fee/Info',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/** 运费账单核对-导出*/
export const API_POST_API_TMS_TRANSPORTSETTE_EXPORT = {
  url: 'api/tms/transportSettle/export',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};
